
import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    title: 'Winners',
    empty: 'No reward recipients yet',
    loadError: 'Failed to load history',
    timeJustNow: 'just now',
    timeMinutesAgo: '{{count}} min ago',
    timeHoursAgo: '{{count}} h ago',
    timeDaysAgo: '{{count}} d ago',
  },
  ru: {
    title: 'Победители',
    empty: 'Пока нет получателей награды',
    loadError: 'Не удалось загрузить историю',
    timeJustNow: 'только что',
    timeMinutesAgo: '{{count}} мин назад',
    timeHoursAgo: '{{count}} ч назад',
    timeDaysAgo: '{{count}} дн назад',
  },
  uz: {
    title: 'Gʻoliblar',
    empty: 'Hali mukofot oluvchilar yoʻq',
    loadError: 'Tarixni yuklab boʻlmadi',
    timeJustNow: 'hozirgina',
    timeMinutesAgo: '{{count}} daq oldin',
    timeHoursAgo: '{{count}} soat oldin',
    timeDaysAgo: '{{count}} kun oldin',
  },
  fa: {
    title: 'برندگان',
    empty: 'هنوز کسی جایزه نگرفته',
    loadError: 'تاریخچه بارگذاری نشد',
    timeJustNow: 'همین الان',
    timeMinutesAgo: '{{count}} دقیقه پیش',
    timeHoursAgo: '{{count}} ساعت پیش',
    timeDaysAgo: '{{count}} روز پیش',
  },
  pt: {
    title: 'Vencedores',
    empty: 'Ainda ninguém recebeu recompensa',
    loadError: 'Não foi possível carregar o histórico',
    timeJustNow: 'agora mesmo',
    timeMinutesAgo: 'há {{count}} min',
    timeHoursAgo: 'há {{count}} h',
    timeDaysAgo: 'há {{count}} d',
  },
  tr: {
    title: 'Kazananlar',
    empty: 'Henüz ödül alan yok',
    loadError: 'Geçmiş yüklenemedi',
    timeJustNow: 'az önce',
    timeMinutesAgo: '{{count}} dk önce',
    timeHoursAgo: '{{count}} sa önce',
    timeDaysAgo: '{{count}} gün önce',
  },
  uk: {
    title: 'Переможці',
    empty: 'Поки немає отримувачів нагороди',
    loadError: 'Не вдалося завантажити історію',
    timeJustNow: 'щойно',
    timeMinutesAgo: '{{count}} хв тому',
    timeHoursAgo: '{{count}} год тому',
    timeDaysAgo: '{{count}} дн тому',
  },
  de: {
    title: 'Gewinner',
    empty: 'Noch keine Belohnungsempfänger',
    loadError: 'Verlauf konnte nicht geladen werden',
    timeJustNow: 'gerade eben',
    timeMinutesAgo: 'vor {{count}} Min.',
    timeHoursAgo: 'vor {{count}} Std.',
    timeDaysAgo: 'vor {{count}} T.',
  },
  es: {
    title: 'Ganadores',
    empty: 'Aún no hay receptores de premios',
    loadError: 'No se pudo cargar el historial',
    timeJustNow: 'ahora mismo',
    timeMinutesAgo: 'hace {{count}} min',
    timeHoursAgo: 'hace {{count}} h',
    timeDaysAgo: 'hace {{count}} d',
  },
  pl: {
    title: 'Zwycięzcy',
    empty: 'Jeszcze nie ma odbiorców nagrody',
    loadError: 'Nie udało się załadować historii',
    timeJustNow: 'przed chwilą',
    timeMinutesAgo: '{{count}} min temu',
    timeHoursAgo: '{{count}} godz. temu',
    timeDaysAgo: '{{count}} dn. temu',
  },
});
